import { supabaseClient } from "@/lib/supabase";
import { isUuid } from "@/services/isUuid";
import { queryOptions, useQuery } from "@tanstack/react-query";
import type { TabKeyT } from "../tabs";

/** The tabs this user sees (roles + studies + admin overrides). */
export async function fetchUserTabAccess(userId: string): Promise<TabKeyT[]> {
    if (!isUuid(userId)) return [];

    const { data, error } = await supabaseClient.rpc("get_user_tab_access", { p_user_id: userId });
    if (error) throw error;

    return (data ?? []).map((row) => row.tab_key as TabKeyT);
}

export const userTabAccessQueryKey = (userId: string) => ["user-tab-access", userId];

export function userTabAccessQueryOptions(userId: string | undefined) {
    return queryOptions({
        queryKey: userTabAccessQueryKey(userId ?? ""),
        queryFn: () => fetchUserTabAccess(userId ?? ""),
        enabled: isUuid(userId),
        staleTime: 5 * 60 * 1000,
    });
}

export function useUserTabAccessQuery(userId: string | undefined) {
    return useQuery(userTabAccessQueryOptions(userId));
}
